<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1">To my parents, Joël and Jeannette, <br/>farmers who taught me to love the good things of the earth, <br/>and so to love life.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mari_9781595585363_oeb_ded_r1.vue?6b7f5a43